import { Advertisement, AdvertisementsService } from "@/client";
import { HttpError } from "@/types/error";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const advertisementsQueryKey = (congressId: string) => {
  return ["advertisements", congressId] as const;
};

function useAdvertisements({
  congressId,
  queryOptions,
}: {
  congressId: string;
  queryOptions?: Partial<UseQueryOptions<Advertisement[], HttpError>>;
}) {
  return useQuery({
    queryKey: advertisementsQueryKey(congressId),
    queryFn: () =>
      AdvertisementsService.getAdvertisementsByCongressId({
        congressId,
      }),
    ...queryOptions,
  });
}

export { advertisementsQueryKey, useAdvertisements };
